import { MouseEventHandler } from 'react';
import styles from './ShotMetadata.module.css';

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export default function DeleteShotButton({ onClick }: Props) {
  return (
    <button className={styles.Action} onClick={onClick}>
      Delete
    </button>
  );
}
